import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Complaint, ComplaintForm, Page } from '../models';

@Injectable()
export class ComplaintService {

    complaintsUrl = environment.dns + 'api/complaints/';

    constructor(private http: HttpClient) { }

    getPaginate(page: number, size: number): Observable<Page<Complaint>> {
        return this.http.get<Page<Complaint>>(this.complaintsUrl + 'paginate?page=' + page + '&size=' + size);
    }

    getOne(id: number): Observable<Complaint> {
        return this.http.get<Complaint>(this.complaintsUrl + id);
    }

    add(complaintForm: ComplaintForm): Observable<Complaint> {
        return this.http.post<Complaint>(this.complaintsUrl, complaintForm);
    }

    update(complaintForm: ComplaintForm): Observable<Complaint> {
        return this.http.put<Complaint>(this.complaintsUrl, complaintForm);
    }

    delete(id: number): Observable<boolean> {
        return this.http.delete<boolean>(this.complaintsUrl + id);
    }
}